import { gql, useMutation } from '@apollo/client';
import React from 'react';
import SVGIcon from '../components/SVGIcon';
import type {
  ReorderFavoriteIdsMutation,
  ReorderFavoriteIdsMutationVariables,
} from '../graphql/generated/graphqlTypes';
import favoriteIcon from '../icons/favorite.svg';
import styles from './ReorderFavoritesModal.module.scss';
import type { ReorderableSidebarItem } from './ReorderSidebarItemsModal';
import ReorderSidebarItemsModal from './ReorderSidebarItemsModal';
import { updateSidebarSettingsCache } from './useSidebarSettings';

const REORDER_FAVORITE_IDS_MUTATION = gql`
  mutation ReorderFavoriteIds($favoriteIds: [ID!]!) {
    updateUserSettings(sidebar: { favoriteIds: $favoriteIds }) {
      sidebar {
        favoriteIds
      }
    }
  }
`;

interface ReorderFavoritesModalProps {
  favorites: ReorderableSidebarItem[];
  close: () => void;
}

const ReorderFavoritesModal = ({
  favorites,
  close,
}: ReorderFavoritesModalProps) => {
  const [reorderFavoriteIds] = useMutation<
    ReorderFavoriteIdsMutation,
    ReorderFavoriteIdsMutationVariables
  >(REORDER_FAVORITE_IDS_MUTATION);

  const handleSubmit = async (favoriteIds: string[]) => {
    await reorderFavoriteIds({
      variables: { favoriteIds },
      update: updateSidebarSettingsCache,
    });
    close();
  };

  return (
    <ReorderSidebarItemsModal
      onSubmit={handleSubmit}
      headerIcon={
        <div className={styles.favoriteIcon}>
          <SVGIcon>{favoriteIcon}</SVGIcon>
        </div>
      }
      header="Favorites"
      title="Reorder Favorites"
      subtitle="Choose the order you want your Favorites to appear in your sidebar"
      items={favorites}
      close={close}
    />
  );
};

export default ReorderFavoritesModal;
